import React from "react";
import PropTypes from "prop-types";

import Image from "../Global/Image";
import Link from "../Global/Link";
import { useSelector } from "react-redux";

const ImageLink = (props) => {
  const { sm, md, lg, imageClassName, linkClassName } = props;
  let { data } = props;

  const stateUrl = useSelector((state) => state.global.steamUrl);
  let linkUrl = data?.link?.url;

  if (data?.link?.url?.toLowerCase()?.includes("steam")) {
    linkUrl = stateUrl;
  }

  return (
    <React.Fragment>
      {data?.link?.url && (
        <Link to={linkUrl} className={linkClassName}>
          <Image
            className={imageClassName}
            src={data?.image?.filename}
            alt={data?.image?.alt}
            sm={sm}
            md={md}
            lg={lg}
          />
        </Link>
      )}
      {!data?.link?.url && (
        <Image
          className={imageClassName}
          src={data?.image?.filename}
          alt={data?.image?.alt}
          sm={sm}
          md={md}
          lg={lg}
        />
      )}
    </React.Fragment>
  );
};

export default ImageLink;

ImageLink.propTypes = {
  data: PropTypes.object,
  sm: PropTypes.string,
  md: PropTypes.string,
  lg: PropTypes.string,
  imageClassName: PropTypes.string,
  linkClassName: PropTypes.string,
};

ImageLink.defaultProps = {
  data: null,
  sm: "",
  md: "",
  lg: "",
  imageClassName: "",
  linkClassName: "",
};
